import { render, staticRenderFns } from "./PublicVideoIndex.vue?vue&type=template&id=f270bd44&scoped=true&"
import script from "./PublicVideoIndex.vue?vue&type=script&lang=js&"
export * from "./PublicVideoIndex.vue?vue&type=script&lang=js&"
import style0 from "./PublicVideoIndex.vue?vue&type=style&index=0&id=f270bd44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f270bd44",
  null
  
)

export default component.exports